import { createMemoryHistory, createBrowserHistory } from 'history';

// This workaround added here is because e2e test runs server side (--testEnvironment=node)
// in order to allow us executing queries to our MongoDB in Memory Database, in consequence, some capabilities are lost
// This is the case of browser history, since is running in the server side, browser history won't be available.
// Looking at the React Router documentation, I've found this
// https://reactrouter.com/en/main/routers/create-memory-router#creatememoryrouter
const browserHistory =
  process.env.NODE_ENV === 'test' ? createMemoryHistory() : createBrowserHistory();

export default browserHistory;
